import MyUseAsyncSelect from './useAsyncSelect'
import MyUseInput from './useInput'
import MyUseInputGroup from './useInputGroup'
import MyUseLocalStorage from './useLocalStorage'
import MyUseSelect from './useSelect'
import MyUseSelectMulti from './useSelectMulti'
import MyUseSessionStorage from './useSessionStorage'
import MyUseSwitch from './useSwitch'
import MyUseTextareaAutosize from './useTextareaAutosize'
import MyUseAsyncCreatableSelect from './useAsyncCreatableSelect'

export const useAsyncSelect = MyUseAsyncSelect
export const useInput = MyUseInput
export const useInputGroup = MyUseInputGroup
export const useLocalStorage = MyUseLocalStorage
export const useSelect = MyUseSelect
export const useSelectMulti = MyUseSelectMulti
export const useSessionStorage = MyUseSessionStorage
export const useSwitch = MyUseSwitch
export const useTextareaAutosize = MyUseTextareaAutosize
export const useAsyncCreatableSelect = MyUseAsyncCreatableSelect